export default () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.5 6.2H8.65352L9 5.99996L4.5 3.40188L4.5 6.2ZM9.5 5.13393C10.1667 5.51883 10.1667 6.48108 9.5 6.86598L5 9.46406C4.33333 9.84896 3.5 9.36784 3.5 8.59804V3.40188C3.5 2.63208 4.33333 2.15096 5 2.53586L9.5 5.13393Z"
			fill="#96714C"
		/>
	</svg>
);
